import React, {Component}     from 'react';
import {
  Button,
  Container,
  Dimmer,
  Divider,
  Form,
  Header,
  Icon,
  Input,
  Loader,
  Message,
  TextArea,
}                             from 'semantic-ui-react';
import PropTypes              from 'prop-types';
import {fromJS}               from 'immutable';

// Global
import getMessage             from '../../global/getMessage';

// Images
// import Gaelle                 from '../../images/gaelle.jpeg';
// Style
import                        '../MainStyle/MainTwo.scss';
import                        './MainContact.scss';
// Controller
import MainContactController  from './MainContactController';

const propTypes = {
  isLoading : PropTypes.bool,
  isSent    : PropTypes.bool,
  lang      : PropTypes.shape({menu: PropTypes.object}),
  locale    : PropTypes.string,
  sendEmail : PropTypes.func.isRequired,
};

const defaultProps = {
  isLoading : false,
  isSent    : false,
  lang      : {},
  locale    : 'en,',
};

const validEmail = (email) => { // see:
  const re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
  return re.test(email);
};

class MainContact extends Component {

  constructor(props) {
    super(props);

    this.state = {
      active  : this.props.isSent,
      email   : null,
      message : null,
      name    : null,
      error   : null,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.timeOut = null;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.isSent && !this.props.isSent) {
      this.setState({active: true}, () => {
        this.timeOut = setTimeout(() => {
          this.setState({'active': false});
        }, 10000);
      });
    }
  }

  handleChange(e, {name, value}) {
    this.setState({[name]: value});
  }

  handleDismiss(e,item) {
    clearTimeout(this.timeOut);
    this.setState({[item.name]: null});
  }

  handleSubmit() {
    const {
      locale,
      sendEmail,
    } = this.props;

    locale;

    const {
      email,
      message,
      name,
    } = this.state;

    if (!email || email && !validEmail(email)) {
      this.setState({error: 'email'}, () => {
        this.timeOut = setTimeout(() => {
          this.setState({error: null});
        }, 3000);
      });
    }
    else if (!message) {
      this.setState({error: 'message'}, () => {
        this.timeOut = setTimeout(() => {
          this.setState({error: null});
        }, 3000);
      });
    }
    else {
      sendEmail(fromJS({
        email,
        message,
        name,
      }));
    }
  }

  handleClose() {
    this.setState({active: false});
  }

  render() {
    const {
      isLoading,
      lang,
    } = this.props;

    const {
      active,
      error,
    } = this.state;

    const errorMsg = error ?
      error === 'email' ?
        'You entered a wrong email format or the field is empty.'
        :
        'Please, add a message.'
      :
      null;

    const messageError = error ?
      (
        <Message
          content={errorMsg}
          header='Error'
          name='error'
          negative
          onDismiss={this.handleDismiss}
        />
      )
      :
      null;

    const formElement = (
      <Form>
        <Dimmer
          active={isLoading}
          page
        >
          <Loader />
        </Dimmer>
        <label>
          {getMessage('section.contact.content.name', lang)}
        </label>
        <Input
          fluid
          name='name'
          onChange={this.handleChange}
          placeholder={getMessage('section.contact.content.placehHolder.name', lang)}
          type='text'
        />
        <br />
        <label>
          {getMessage('section.contact.content.email')}
        </label>
        <Input
          fluid
          name='email'
          onChange={this.handleChange}
          placeholder={getMessage('section.contact.content.placehHolder.email', lang)}
          type='email'
        />
        <br />
        <label>
          {getMessage('section.contact.content.message')}
        </label>
        <TextArea
          name='message'
          onChange={this.handleChange}
          placeholder={getMessage('section.contact.content.placeHolder.message', lang)}
          rows={4}
        />

        <Divider hidden />

        <Button
          content={getMessage('section.contact.button', lang)}
          disabled={isLoading}
          loading={isLoading}
          onClick={this.handleSubmit}
        />
      </Form>
    );

    return (
      <Container className='sgr-mainHome-grid-two-sub'>

        <Divider hidden />

        <Header
          as='h2'
          color='grey'
          inverted
          textAlign='center'
        >
          <Header.Content>
            <Icon
              name='mail outline'
              size='huge'
            />
            {getMessage('section.contact.header.title', lang)}
          </Header.Content>
          <Header.Subheader>
            {getMessage('section.contact.header.subTitle', lang)}
          </Header.Subheader>
        </Header>

        {messageError}

        {formElement}

        {
          active &&
          <Dimmer
            active
            className='dimmer-email'
            onClickOutside={this.handleClose}
            page
          >
            <Header
              as='h2'
              icon
              inverted
            >
              <Icon name='music' />
              {'Thanks!'}
              <Header.Subheader>
                {'I will be in touch as soon as possible.'}
              </Header.Subheader>

              <Icon
                className='dimmer-close'
                name='close'
                onClick={this.handleClose}
                size='mini'
              />

            </Header>
          </Dimmer>
        }

      </Container>
    );
  }

}

MainContact.propTypes = propTypes;
MainContact.defaultProps = defaultProps;

export const MainContactTest = MainContact;

export default MainContactController(MainContact);



// WEBPACK FOOTER //
// ./src/organisms/MainContact/MainContact.js